// extracted by mini-css-extract-plugin
export default {"sharing-status-text":"caztYvdgY8YECKFt5t8w","status-text":"Yh7rm8OFZQgErSQRLfLb","purl":"Gm4gHgcwuVuPOShA9ObQ","shared-by":"EcPBz7y2twMBFyH99Vos"};